import { render, staticRenderFns } from "./Concepts.vue?vue&type=template&id=68bb0d81"
import script from "./Concepts.vue?vue&type=script&lang=js"
export * from "./Concepts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports